import React from 'react'
import './nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {BiMessageSquareDetail} from 'react-icons/bi'
import { IoCodeWorkingSharp } from "react-icons/io5";
import {useState} from 'react'


const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href='#' onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ''}><AiOutlineHome/></a>
      <a href='#portfolio' onClick={() => setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ''}><IoCodeWorkingSharp/></a>
      <a href='#Contact' onClick={() => setActiveNav('#Contact')} className={activeNav === '#Contact' ? 'active' : ''}><BiMessageSquareDetail/></a>
      
    </nav>
  )
}

export default Nav